<kendo-dialog title="Schedule Meeting" (close)="onCancelSHM()" [maxWidth]="1900" [width]="1400" [minHeight]="300"
  (click)="stopClickPropagation($event)" (keydown.space)="stopClickPropagation($event)"
  [animation]="{ duration: 300, type: 'fade', direction: 'down' }" [themeColor]="'primary'"
  class="schedule-meeting-dialog">
  <div *ngIf="form">
    <div class="padding-top">
      <app-student-info [studentDetails]="studentProfile" *ngIf="nycIds" [studentOSISId$]="nycIds" [showAction]="false"
        [showLoadingSpinner]="false"
        (loaded)="handleStudentInfoLoaded()"></app-student-info>
    </div>
    <form class="schshm-container k-p-8 k-bg-white" [formGroup]="form">
      <div class="shm-heading">
        <div class="k-d-inline-flex">
          <fa-icon icon="calendar" class="fa-md k-pr-xs k-pb-2 icon-color k-align-self-center"></fa-icon>
          <h2 class="k-mb-6">
            {{ menuTitle }}
          </h2>
        </div>
      </div>
      <div class="flex">
        <div class="k-d-inline-block w-75">
          <div class="k-pr-4">
            <!-- ****************************** STAFF CONTACT DETAILS ****************************** -->
            <div
              *ngIf="(isMeetingTypeAnual && (meetingType === 4|| meetingType === 99 || meetingType === 98)) || (submeetingType === meetingSettingTypeENUM.Annual)"
              class="k-mt-3">
              Now that almost a year has passed since an IEP was developed for your child, an Annual Review has been
              scheduled to discuss the results. As a member of the Committee, you have a right to participate in
              discussions and decisions about the identification, evaluation and educational placement of your child.
              The
              meeting has been scheduled for the following date, time and location.
            </div>
            <div
              *ngIf="!isMeetingTypeAnual && (meetingType === 4|| meetingType === 99 || meetingType === 98) && !(submeetingType === meetingSettingTypeENUM.Annual)"
              class="k-mt-3">
              We have scheduled a meeting of the Committee on Special Education to discuss {{studentProfile?.firstName}}
              {{studentProfile?.lastName}} educational needs. Your participation in this meeting is very important and
              you
              are encouraged to attend. As a member of the Committee, you have a right to participate in discussions and
              decisions about the identification, evaluation and educational placement of your child. The meeting has
              been
              scheduled for the following date, time and location.
            </div>
            <div class="contact-details k-mt-8">
              <div class="k-d-inline-flex k-mb-2">
                <fa-icon icon="user" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                <h3 class="k-m-0">Contact Details</h3>
              </div>

              <div class="k-d-flex k-justify-content-stretch">
                <div class="k-mr-2 k-mb-2 k-w-full">
                  <kendo-formfield showHints="always" showErrors="initial">
                    <kendo-floatinglabel text="Contact Name *" class="k-w-full">
                      <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                        formControlName="contactName" [readonly]="viewMode">
                      </kendo-textbox>
                    </kendo-floatinglabel>
                    <kendo-formerror>Error: Please enter Staff Contact Name</kendo-formerror>
                  </kendo-formfield>
                </div>
                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                  <kendo-formfield showHints="always" showErrors="initial">
                    <kendo-floatinglabel text="Contact Phone *" class="k-w-full">
                      <kendo-maskedtextbox [size]="'medium'" [rounded]="'large'" [fillMode]="'outline'"
                        formControlName="contactPhone" mask="(000) 000-0000"
                        [readonly]="viewMode">
                        <!---Dev: The [includeLiterals] property determines whether the formatted value (including literals like parentheses, spaces, and dashes) is returned in raw value--->
                      </kendo-maskedtextbox>
                    </kendo-floatinglabel>
                    <kendo-formerror *ngIf="form.get('contactPhone')?.touched && form.get('contactPhone')?.invalid">
                      {{ form.get('contactPhone')?.errors?.validatePhoneNumberMaskedTextBox?.message || (form.get('contactPhone')?.errors?.required ? 'Error: Field is required' : 'Please enter valid 10-digit phone number') }}
                    </kendo-formerror>
                  </kendo-formfield>
                </div>
                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                  <kendo-formfield showHints="always" showErrors="initial">
                    <kendo-floatinglabel text="Contact Email Address *" class="k-w-full">
                      <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                        formControlName="contactEmail" [readonly]="viewMode">
                      </kendo-textbox>
                    </kendo-floatinglabel>
                    <kendo-formerror>{{
                      form.get("contactEmail")?.errors?.validateEmail?.message
                      }}</kendo-formerror>
                  </kendo-formfield>
                </div>
              </div>
              <!-- </div> -->
              <!-- ****************************** END STAFF CONTACT DETAILS ****************************** -->

              <!-- ****************************** NOTIFICATION/RECIPIENT DETAILS ****************************** -->
              <div class="notification-details k-mb-8">

                <!-- <div class="k-d-inline-flex w-50">
                <fa-icon icon="envelope" class="fa-md k-pr-2 icon-color k-align-self-center"></fa-icon>
                <h3 class="k-m-0">Delivery Method *</h3>
              </div> -->

                <div class="k-justify-content-stretch k-d-flex">
                  <!-- <div class="delivery-method k-d-flex k-justify-content-stretch">
                  <div class="k-ml-2 k-mr-2">
                    <div class="k-w-full">
                      <div class="k-mt-2">
                        <input type="checkbox" #PostalMail value="postalMail" 
                        [size]="'medium'"
                          formControlName="postalMail" [rounded]="'medium'" value="true" kendoCheckBox
                          #deliveryMethod />
                        <kendo-label text="Postal Mail" [for]="PostalMail" class="k-mr-1"></kendo-label>
                   
                        <input type="checkbox" #parentPortal value="parentPortal" [size]="'medium'"
                          formControlName="parentPortal" [rounded]="'medium'" value="true" kendoCheckBox
                          #deliveryMethod />
                        <kendo-label text="Parent Portal" [for]="parentPortal"></kendo-label>
                      </div>
                    </div>
                  </div>
                </div> -->

                  <div class="k-w-full">
                    <kendo-formfield k-w-full showHints="always" showErrors="initial">
                      <kendo-floatinglabel text="Recipient *" class="k-w-full">
                        <kendo-dropdownlist [data]="allPossibleAttendees" class="k-dropdownlist-recipient"
                          textField="displayName" valueField="displayName" [rounded]="'large'" [size]="'medium'"
                          formControlName="selectedRecipient" placeholder="Please select a recipient...">
                          <ng-template kendoDropDownListNoDataTemplate>
                            <div class="no-records-found">
                              <div class="bold-text">No contacts available.</div>
                              <div>This student has no eligible contacts to select from. Please check student profile
                                for
                                more info.</div>
                            </div>
                          </ng-template>
                        </kendo-dropdownlist>
                      </kendo-floatinglabel>
                      <kendo-formerror>Error: Please enter recipient contact
                        information.</kendo-formerror>
                    </kendo-formfield>
                  </div>

                  <div style="flex: 0 0 32%" *ngIf="showElectronicDeliveryMethods">
                    <kendo-formfield showHints="always" showErrors="initial">
                      <kendo-floatinglabel text="Recipient Email Address" class="k-w-full">
                        <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                          formControlName="recipientEmailAddress" [readonly]="viewMode">
                        </kendo-textbox>
                      </kendo-floatinglabel>
                      <kendo-formerror>{{
                        form.get("recipientEmailAddress")?.errors?.validateEmail
                        ?.message
                        }}</kendo-formerror>
                    </kendo-formfield>
                  </div>
                </div>
              </div>
            </div>
            <!-- ****************************** END NOTIFICATION/RECIPIENT DETAILS ****************************** -->

            <!-- ****************************** MEETING LOCATION ****************************** -->
            <div class="meeting-details k-my-8">
              <div class="k-d-inline-flex k-mb-2">
                <fa-icon icon="location-dot" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                <h3 class="k-m-0">Meeting Location</h3>
              </div>
              <div class="k-d-flex k-justify-content-stretch k-flex-wrap k-gap-2">
                <div style="flex: 0 0 70%">
                  <kendo-formfield showHints="always" showErrors="initial">
                    <kendo-floatinglabel text="Address *" class="k-w-full">
                      <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                        formControlName="meetingStreetAddress1" [readonly]="viewMode">
                      </kendo-textbox>
                    </kendo-floatinglabel>
                    <kendo-formerror>{{
                      form.get("meetingStreetAddress1")?.errors?.validateAddress
                      ?.message
                      }}</kendo-formerror>
                  </kendo-formfield>
                </div>

                <div>
                  <kendo-formfield showHints="always" showErrors="initial">
                    <kendo-floatinglabel text="Floor-Room" class="k-w-full">
                      <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                        formControlName="meetingFloorRoom" [readonly]="viewMode">
                      </kendo-textbox>
                    </kendo-floatinglabel>
                    <kendo-formerror>Error: Please enter meeting location
                      details.</kendo-formerror>
                  </kendo-formfield>
                </div>
              </div>
            </div>
            <div class="transition-services k-mb-6"
              *ngIf="studentProfile?.age >= 14 && (meetingType === 4|| meetingType === 99 || meetingType === 98)">
              <h3 class="k-m-0" id="transitionServicesProviderHeading">Transition Services Provider</h3>
            <div role="group" aria-labelledby="transitionServicesProviderHeading">
              <ng-container *ngFor="let provider of providers">
                <div class="k-d-flex k-align-items-center k-gap-2 k-mb-2">
                  <input type="checkbox" size="medium" kendoCheckBox [formControlName]="provider?.controlName"
                    [attr.aria-label]="provider.text" [disabled]="viewMode" />

                  <kendo-label class="k-checkbox-label">
                    {{ provider.text }}
                  </kendo-label>
                </div>
              </ng-container>
            </div>

              <!-- Other Provider textbox -->
              <div *ngIf="form.get('other')?.value" class="k-mt-3">
                <kendo-formfield class="k-w-full">
                  <kendo-label text="Other Provider *"></kendo-label>
                  <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                    class="k-w-full" formControlName="otherProvider" [readonly]="viewMode">
                  </kendo-textbox>
                  <kendo-formerror>Error: Field is required.</kendo-formerror>
                </kendo-formfield>
              </div>
            </div>
            <!-- ****************************** END MEETING LOCATION ****************************** -->

            <!-- ****************************** ATTENDEES LIST ****************************** -->
            <div class="k-d-inline-flex k-mb-2" id="attendeesSectionHeading"
              *ngIf="meetingType === 4 || meetingType === 99 || meetingType === 98 || meetingType === 1">
              <fa-icon icon="user-group" class="fa-md k-pr-xs icon-color k-align-self-center" aria-hidden="true"></fa-icon>
              <h3 class="k-m-0">Attendees</h3>
              <h3 class="k-mb-2 k-ml-1" *ngIf="showstudent || showParent || showSchoolPsychologist ||
                showdistrictRepresentative || showGeneralEducationTeacher || showSpecialEducationTeacher ||
                  showSchoolSocialWorker || showRelatedServiceProvider || showPrincipal || showTeacher ">
                Required
              </h3>
            </div>
            <div class="container k-mt-2" role="group" aria-labelledby="attendeesSectionHeading"
              *ngIf="meetingType === 4|| meetingType === 99 || meetingType === 98 || meetingType === 1">
              <!-- Student -->
              <div class="content k-ml-2" *ngIf="showstudent">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="student">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="user-graduate"
                          class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon><kendo-label text="Student *"
                          class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-dropdownlist [data]="studentList" formControlName="studentName" [rounded]="'large'"
                          [textField]="'description'" [valueField]="'id'" [size]="'medium'" class="k-dropdownlist"
                          [readonly]="viewMode"></kendo-dropdownlist>
                        <!--<kendo-formerror>Error: Please enter meeting location details.</kendo-formerror>-->
                      </div>

                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="studentEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get("student.studentEmail")?.errors
                            ?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>

              <!-- Parent -->
              <div class="content k-ml-2" *ngIf="showParent">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="parent">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="shield-heart" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="Parent *" [for]="requiredParentName"
                          class="student-document__label bold-label"> </kendo-label>
                        <kendo-combobox [data]="parentList" formControlName="parentName" [rounded]="'large'"
                          #requiredParentName [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                          class="k-dropdownlist" [allowCustom]="true" [readonly]="viewMode"></kendo-combobox>
                        <!--<kendo-formerror>Error: Field is required.</kendo-formerror>-->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="parentEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get("parent.parentEmail")?.errors
                            ?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>

              <!-- School Psychologist -->
              <div class="content k-ml-2" *ngIf="showSchoolPsychologist">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="schoolPsychologist">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="brain" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="School Psychologist *" [for]="schoolPsychologistName" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="schoolPsychologistsList" formControlName="schoolPsychologistName"
                          [rounded]="'large'"  #schoolPsychologistName [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                          class="k-dropdownlist" [allowCustom]="true" [readonly]="viewMode"
                          aria-label="School Psychologist"></kendo-combobox>
                        <!--<kendo-formerror>Error: Field is required.</kendo-formerror>-->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="schoolPsychologistEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('schoolPsychologist.schoolPsychologistEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>

              <!-- District Representative -->
              <div class="content k-ml-2" *ngIf="showdistrictRepresentative">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="districtRepresentative">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="user-tie" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="District Representative *" [for]="districtRepresentativerName" class="student-document__label bold-label"
                          style="display: inline-flex">
                        </kendo-label>
                        <kendo-combobox [data]="districtRepresentativeList" formControlName="districtRepresentativerName" [rounded]="'large'"
                          #districtRepresentativerName [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                          class="k-dropdownlist" [allowCustom]="true" [readonly]="viewMode"
                          aria-label="District Representative">
                        </kendo-combobox>
                        <!--<kendo-formerror>Error: Field is required.</kendo-formerror>-->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial" style="margin-top: -50px">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="districtRepresentativerEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('districtRepresentative.districtRepresentativerEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>

              <!-- General Education Teacher  -->

              <div class="content k-ml-2" *ngIf="showGeneralEducationTeacher">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="generalEducationTeacher">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="apple-whole" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="General Education Teacher *" [for]="generalEducationTeacherName" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="generalEducationTeacherList"
                          formControlName="generalEducationTeacherName" [rounded]="'large'" [textField]="'description'"
                          [valueField]="'id'" [size]="'medium'" class="k-dropdownlist" [allowCustom]="true"
                          #generalEducationTeacherName [readonly]="viewMode" aria-label="General Education Teacher"></kendo-combobox>
                        <!--<kendo-formerror>Error: Field is required.</kendo-formerror>-->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="generalEducationTeacherEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('generalEducationTeacher.generalEducationTeacherEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>

              <!-- Special Educational Teacher -->
              <div class="content k-ml-2" *ngIf="showSpecialEducationTeacher">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="specialEducationTeacher">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="chalkboard-user" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="Special Education Teacher *" [for]="specialEducationTeacherName" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="specialEducationTeacherList"
                          formControlName="specialEducationTeacherName" [rounded]="'large'" [textField]="'description'"
                          [valueField]="'id'" [size]="'medium'" class="k-dropdownlist" [allowCustom]="true"
                          #specialEducationTeacherName [readonly]="viewMode" aria-label="Special Education Teacher"></kendo-combobox>
                        <!--<kendo-formerror>Error: Field is required.</kendo-formerror>-->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="specialEducationTeacherEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('specialEducationTeacher.specialEducationTeacherEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>

              <!-- School Social Worker -->
              <div class="content k-ml-2" *ngIf="showSchoolSocialWorker">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="schoolSocialWorker">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="user-nurse" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="School Social Worker *" [for]="schoolSocialWorkerName" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="schoolSocialWorkerList" formControlName="schoolSocialWorkerName"
                          [rounded]="'large'" [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                          class="k-dropdownlist" #schoolSocialWorkerName [allowCustom]="true" [readonly]="viewMode"
                          aria-label="School Social Worker"></kendo-combobox>
                        <!--<kendo-formerror>Error: Field is required.</kendo-formerror>-->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="schoolSocialWorkerEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('schoolSocialWorker.schoolSocialWorkerEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>

              <!-- Related Service Provider -->
              <div class="content k-ml-2" *ngIf="showRelatedServiceProvider">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="relatedServiceProvider">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="building-user" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="Related Service Provider *" [for]="relatedServiceProviderName" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="relatedServiceProviderList" formControlName="relatedServiceProviderName"
                          [rounded]="'large'" [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                          class="k-dropdownlist" [allowCustom]="true" #relatedServiceProviderName [readonly]="viewMode"
                          aria-label="Related Service Provider"></kendo-combobox>
                        <!--<kendo-formerror>Error: Field is required.</kendo-formerror>-->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="relatedServiceProviderEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('relatedServiceProvider.relatedServiceProviderEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>

              <!-- Principal -->
              <div class="content k-ml-2" *ngIf="showPrincipal">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="principal">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="chalkboard-teacher"
                          class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="Principal *" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="principalList" formControlName="principalName" [rounded]="'large'"
                          [textField]="'description'" [valueField]="'id'" [size]="'medium'" class="k-dropdownlist"
                          [allowCustom]="true" [readonly]="viewMode"></kendo-combobox>
                        <!-- <kendo-formerror>Error: Please enter meeting location details.</kendo-formerror> -->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="principalEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <!-- <kendo-formerror>Error: Please enter meeting location details.</kendo-formerror> -->
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>

              <!-- Teacher -->
              <div class="content k-ml-2" *ngIf="showTeacher">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="teacher">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="chalkboard-teacher"
                          class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="Teacher *" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="teacherList" formControlName="teacherName" [rounded]="'large'"
                          [textField]="'description'" [valueField]="'id'" [size]="'medium'" class="k-dropdownlist"
                          [allowCustom]="true" [readonly]="viewMode"></kendo-combobox>
                        <!-- <kendo-formerror>Error: Please enter meeting location details.</kendo-formerror> -->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="teacherEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get("teacher.teacherEmail")?.errors
                            ?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>
            </div>
            <!----------------------------------Show Optional Attendees---------------------------------------------------->

            <div class="k-d-flex k-justify-content-stretch k-mt-6"
              *ngIf="meetingType === 4|| meetingType === 99 || meetingType === 98 || meetingType === 1">
              <h3 class="k-mb-2" id="attendeesOptionalHeading" *ngIf="showParentOptional || showGeneralEducationTeacherOptional ||
             showSpecialEducationTeacherOptional || showSchoolSocialWorkerOptional || showRelatedServiceProviderOptional ||
              showSchoolPsychologistOptional || showdistrictRepresentativeOPtional">
                Optional
              </h3>
            </div>
            <div class="container k-mt-2" role="group" aria-labelledby="attendeesOptionalHeading"
              *ngIf="meetingType === 4|| meetingType === 99 || meetingType === 98 || meetingType === 1">
              <!-- Student Parent -->
              <div class="content k-ml-2" *ngIf="showParentOptional">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="parent">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="shield-heart" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="Parent" [for]="optionalParentName"
                          class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="parentList" formControlName="parentName" [rounded]="'large'"
                          #optionalParentName [size]="'medium'" [allowCustom]="true"
                          [readonly]="viewMode"></kendo-combobox>
                        <!-- <kendo-formerror>Error: Please enter meeting location details.</kendo-formerror> -->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="parentEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get("parent.parentEmail")?.errors
                            ?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>
              <!-- General Education Teacher  ||  Special Educational Teacher  -->
              <div class="content k-ml-2" *ngIf="showGeneralEducationTeacherOptional">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="generalEducationTeacher">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="apple-whole" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="General Education Teacher" [for]="generalEducationTeacherNameOptional" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="generalEducationTeacherList"
                          formControlName="generalEducationTeacherName" [rounded]="'large'" [textField]="'description'"
                          [valueField]="'id'" [size]="'medium'" [allowCustom]="true"
                          #generalEducationTeacherNameOptional [readonly]="viewMode" aria-label="General Education Teacher"></kendo-combobox>
                        <!-- <kendo-formerror>Error: Please enter meeting location details.</kendo-formerror> -->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="generalEducationTeacherEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('generalEducationTeacher.generalEducationTeacherEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>
              <div class="content k-ml-2" *ngIf="showSpecialEducationTeacherOptional">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="specialEducationTeacher">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="chalkboard-user" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="Special Education Teacher" [for]="specialEducationTeacherNameOptional" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="specialEducationTeacherList"
                          formControlName="specialEducationTeacherName" [rounded]="'large'" [textField]="'description'"
                          [valueField]="'id'" [size]="'medium'" [allowCustom]="true"
                          #specialEducationTeacherNameOptional [readonly]="viewMode"
                          aria-label="Special Education Teacher"></kendo-combobox>
                        <!--  <kendo-formerror>Error: Please enter meeting location details.</kendo-formerror> -->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="specialEducationTeacherEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('specialEducationTeacher.specialEducationTeacherEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>
              <!-- School Social Worker  ||  Related Service Provider  -->

              <div class="content k-ml-2" *ngIf="showSchoolSocialWorkerOptional && meetingType !== 1">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="schoolSocialWorker">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="user-nurse" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="School Social Worker" [for]="schoolSocialWorkerNameOptional" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="schoolSocialWorkerList" formControlName="schoolSocialWorkerName"
                          [rounded]="'large'" [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                          [allowCustom]="true" #schoolSocialWorkerNameOptional [readonly]="viewMode"
                          aria-label="School Social Worker"></kendo-combobox>
                        <!-- <kendo-formerror>Error: Please enter meeting location details.</kendo-formerror> -->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="schoolSocialWorkerEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('schoolSocialWorker.schoolSocialWorkerEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>
              <div class="content k-ml-2" *ngIf="showRelatedServiceProviderOptional && meetingType !== 1">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="relatedServiceProvider">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="building-user" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="Related Service Provider" [for]="relatedServiceProviderNameOptional" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="relatedServiceProviderList" formControlName="relatedServiceProviderName"
                          [rounded]="'large'" [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                          [allowCustom]="true" #relatedServiceProviderNameOptional [readonly]="viewMode"
                          aria-label="Related Service Provider"></kendo-combobox>
                        <!--  <kendo-formerror>Error: Please enter meeting location details.</kendo-formerror> -->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="relatedServiceProviderEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('relatedServiceProvider.relatedServiceProviderEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>
              <!-- School Psychologist ||  District Representative  -->
              <div class="content k-ml-2" *ngIf="showSchoolPsychologistOptional">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="schoolPsychologist">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="brain" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
                        <kendo-label text="School Psychologist" [for]="schoolPsychologistNameOptional" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="schoolPsychologistsList" formControlName="schoolPsychologistName"
                          [rounded]="'large'" #schoolPsychologistNameOptional [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                          [allowCustom]="true" [readonly]="viewMode" aria-label="School Psychologist"></kendo-combobox>
                        <!-- <kendo-formerror>Error: Please enter meeting location details.</kendo-formerror> -->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="schoolPsychologistEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('schoolPsychologist.schoolPsychologistEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>
              <div class="content k-ml-2" *ngIf="showdistrictRepresentativeOPtional">
                <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                  <kendo-card-header class="k-vstack w-95 !k-p-0">
                    <div class="k-d-flex k-justify-content-stretch" formGroupName="districtRepresentative">
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                        <fa-icon icon="user-tie" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>

                        <kendo-label text="District Representative" [for]="districtRepresentativerNameOptional" class="student-document__label bold-label">
                        </kendo-label>
                        <kendo-combobox [data]="districtRepresentativeList" formControlName="districtRepresentativerName" [rounded]="'large'"
                          #districtRepresentativerNameOptional [textField]="'description'" [valueField]="'id'" [size]="'medium'"
                          [allowCustom]="true" [readonly]="viewMode"
                          aria-label="District Representative">
                        </kendo-combobox>
                        <!-- <kendo-formerror>Error: Please enter meeting location details.</kendo-formerror> -->
                      </div>
                      <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full email-align">
                        <kendo-formfield showHints="always" showErrors="initial">
                          <kendo-floatinglabel text="Email" class="k-w-full">
                            <kendo-textbox [clearButton]="true" [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="districtRepresentativerEmail" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            form.get('districtRepresentative.districtRepresentativerEmail')?.errors?.validateEmail?.message
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                    </div>
                  </kendo-card-header>
                </kendo-card>
              </div>
            </div>

            <!-- ****************************** END ATTENDEES LIST ****************************** -->

            <!-- ****************************** ADD ATTENDEE FORM ****************************** -->

            <div *ngIf="meetingType === 4|| meetingType === 99 || meetingType === 98 || meetingType === 1">
              <h4 class="k-mt-6 k-mb-4">Additional</h4>
              <ng-container formArrayName="attendee">
                <ng-container *ngFor="let objectives of getControls(); let i = index" [formGroupName]="i">
                  <kendo-card orientation="horizontal" class="!k-w-full k-h-full k-px-6 k-pt-6 k-pb-3 k-mb-2">
                    <kendo-card-header class="k-vstack w-95 !k-p-0">
                      <div class="k-d-flex k-flex-nowrap">
                        <!-- Remove Icon -->
                        <div class="attendee-remove-slot">
                          <button *ngIf="i > 0 && getControls().length > minAttendeeCount" type="button" kendoButton
                            fillMode="flat" [svgIcon]="xmarkIcon" aria-label="Remove attendee" class="fa-md k-mt-8"
                            [disabled]="viewMode" (click)="removeAttendee(i)"></button>
                        </div>

                        <kendo-formfield showHints="always" showErrors="initial" class="k-my-2 k-w-full k-mr-4">
                          <kendo-floatinglabel text="Role">
                            <kendo-combobox [data]="filteredMeetingRoles" (ngModelChange)="showAttendeeLookupList(i)"
                              [textField]="'description'" (valueChange)="valueRoleChange(i)" [valueField]="'id'"
                              [valuePrimitive]="true" [rounded]="'large'" [size]="'medium'" formControlName="role"
                              [allowCustom]="true" [readonly]="viewMode"></kendo-combobox>
                          </kendo-floatinglabel>
                          <kendo-formerror>Error: Please select role</kendo-formerror>
                        </kendo-formfield>
                        <kendo-formfield showHints="always" showErrors="initial" class="k-my-2 k-w-full k-mr-4">
                          <kendo-floatinglabel [text]="objectives.get('isRequired')?.value ? 'Name *' : 'Name'"
                            class="k-w-full">
                            <kendo-combobox [data]="attendeeLookupList[i]" textField="displayName"
                              [textField]="'description'" [valueField]="'id'" [rounded]="'large'" [size]="'medium'"
                              formControlName="selectedAttendee" (ngModelChange)="getEmailData(i)" [allowCustom]="true"
                              [readonly]="viewMode"></kendo-combobox>
                          </kendo-floatinglabel>
                          <kendo-formerror>Error: Please select attendee</kendo-formerror>
                        </kendo-formfield>

                        <kendo-formfield showHints="always" showErrors="initial" class="k-my-2 k-w-full">
                          <kendo-floatinglabel [text]="objectives.get('isRequired')?.value ? 'Email *' : 'Email'"
                            class="k-w-full">
                            <kendo-textbox [size]="'medium'" rounded="large" [fillMode]="'outline'"
                              formControlName="email" [readonly]="viewMode">
                            </kendo-textbox>
                          </kendo-floatinglabel>
                          <kendo-formerror>{{
                            getValidateValidationMessage("email", i)
                            }}</kendo-formerror>
                        </kendo-formfield>
                      </div>
                      <div class="k-d-flex k-flex-nowrap k-justify-content-between k-align-items-stretch">
                        <p class="disabled-text k-font-semibold font-size-14 k-m-0"></p>
                        <div>
                          <kendo-label [for]="isRequired" text="Required" class="k-pr-xs"></kendo-label>
                          <input type="checkbox" [size]="'medium'" kendoCheckBox formControlName="isRequired"
                            #isRequired [disabled]="viewMode" />
                        </div>
                      </div>
                    </kendo-card-header>
                  </kendo-card>
                </ng-container>

              </ng-container>

            </div>
            <div class="k-pt-2"
              *ngIf="meetingType === 4 || meetingType === 99 || meetingType === 98 || meetingType === 1">
              <button kendoButton (click)="AddAttendee()" [svgIcon]="plusIcon" fillMode="outline" themeColor="primary"
                [disabled]="viewMode" size="large" rounded="large">
                New Attendee
              </button>
            </div>

          </div>
        </div>
        <!-- ****************************** END ADD ATTENDEE FORM ****************************** -->

        <!-- ****************************** DATE/TIME PICKER ****************************** -->
        <div class="right-block k-d-inline-block k-align-top">
          <div class="k-p-6">
            <div class="k-d-inline-flex">
              <fa-icon icon="calendar" class="fa-md k-pr-xs icon-color k-align-self-center"></fa-icon>
              <h3 class="k-m-0">Meeting Time</h3>
            </div>
            <div *ngIf="meetingType === meetingTypeEnum.SHM">
              <h4 class="k-m-0 k-pt-2 k-pb-1">SHM Due Date</h4>
              <!-- <p class="k-m-0">{{ dueDate | date:'MM/dd/yyyy' }}</p> -->
            </div>
            <div>
              <kendo-formfield class="date-width k-d-flex">
                <kendo-floatinglabel text="Meeting Date *" class="k-my-2 k-w-full">
                  <kendo-datepicker calendarType="classic" rounded="large" placeholder="MM/DD/YYYY"
                    formControlName="meetingDate" [format]="format" [min]="minMeetingDate" [max]="maxMeetingDate"
                    [readonly]="viewMode"></kendo-datepicker>
                </kendo-floatinglabel>
                <kendo-formhint *ngIf="!form.get('meetingDate')?.invalid || !form.get('meetingDate')?.touched" class="sr-only">{{ datePickerHint }}</kendo-formhint>
                <kendo-formerror *ngIf="form.get('meetingDate')?.invalid && (form.get('meetingDate')?.touched || form.get('meetingDate')?.dirty)">
                  <ng-container *ngIf="form.get('meetingDate')?.errors?.required">Error: Please select Meeting date</ng-container>
                  <ng-container *ngIf="form.get('meetingDate')?.errors?.maxError && meetingType === meetingTypeEnum.SHM">Error: Date cannot be more than 1 year from today</ng-container>
                  <ng-container *ngIf="form.get('meetingDate')?.errors?.minError && meetingType === meetingTypeEnum.SHM">Error: Date can not be earlier than Date of Initial Referral</ng-container>
                  <ng-container *ngIf="form.get('meetingDate')?.errors?.minError && meetingType === meetingTypeEnum.AnnualReview">Error: Date can not be more than 180 days before the annual review date</ng-container>
                </kendo-formerror>
              </kendo-formfield>
              <div>
                <kendo-formfield>
                  <kendo-floatinglabel text="Start Time *" class="k-mb-2 k-w-full">
                    <kendo-timepicker formControlName="meetingStartTime" placeholder=""
                      [min]="meetingType === meetingTypeEnum.GenEd ? genTimePickerMin : timePickerMin"
                      [max]="meetingType === meetingTypeEnum.GenEd ? genTimePickerMax : timePickerMax"
                      [value]="timePickerValue" [rangeValidation]="true" [steps]="{ hour: 1, minute: 30}"
                      [readonly]="viewMode"></kendo-timepicker>
                  </kendo-floatinglabel>
                  <kendo-formhint *ngIf="!form.get('meetingStartTime')?.invalid || !form.get('meetingStartTime')?.touched" class="sr-only">{{ timePickerHint }}</kendo-formhint>
                  <kendo-formerror *ngIf="form.get('meetingStartTime')?.invalid && (form.get('meetingStartTime')?.touched || form.get('meetingStartTime')?.dirty) && form.get('meetingStartTime')?.errors?.required">Error: Please select start time</kendo-formerror>
                </kendo-formfield>
              </div>
              <div *ngIf="
                  caseStage === 'Initial' &&
                  meetingType === meetingTypeEnum.IEP &&
                  !isMeetingTypeAnnual
                ">
                <kendo-formfield showHints="always">
                  <kendo-floatinglabel text="Date of Consent" class="k-mb-2 k-w-full">
                    <kendo-datepicker calendarType="classic" rounded="large" placeholder="MM/DD/YYYY"
                      [format]="displayFormat" formControlName="consentDate" [readonly]="true"></kendo-datepicker>
                  </kendo-floatinglabel>
                </kendo-formfield>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ****************************** END DATE/TIME PICKER ****************************** -->

      <!-- ****************************** SCHEDULE/CANCEL ACTIONS ****************************** -->
      <div class="k-ml-2 k-mr-2 k-mb-2 k-mt-4 k-w-full" *ngIf="showSpecialInstructions">
        <kendo-label text="Additional/Special Instructions" class="student-document__label">
        </kendo-label>
        <kendo-formfield class="!k-mt-0" showHints="always">
          <kendo-textarea placeholder="Type here" formControlName="specialinstructions"
            class="student-document__textarea" [rows]="3" resizable="vertical" [readonly]="viewMode"></kendo-textarea>
        </kendo-formfield>
      </div>
      <div class="k-ml-2 k-mr-2 k-mb-2 k-mt-3 w-25" *ngIf="showTranslationLanguage">
        <kendo-formfield k-w-full showHints="always" showErrors="initial">
          <kendo-floatinglabel text="Language to Translate the Document Into" class="k-w-full">
            <kendo-dropdownlist [data]="referenceData.languages" [textField]="'description'" [valueField]="'id'"
              [rounded]="'large'" [size]="'medium'" formControlName="translationLanguage"
              [readonly]="viewMode"></kendo-dropdownlist>
          </kendo-floatinglabel>
        </kendo-formfield>
      </div>
      
      <!-- ****************************** END SCHEDULE/CANCEL ACTIONS ****************************** -->
      <kendo-dialog-actions class="k-px-0 k-pb-0">
        <div class="k-mt-2 k-text-left margin">
          <div class="action-btns footer k-d-flex k-justify-content-between">
            <div>
              <button class="button-size" kendoButton size="large" rounded="large" fillMode="outline" themeColor="error"
                (click)="openConfirmationDialog(); stopClickPropagation($event)">
                Cancel
              </button>
            </div>
            <div>
              <button class="button-size" [disabled]="isScheduleDisabled || isScheduling"
                *ngIf="showScheduleBtn && !viewMode" kendoButton themeColor="primary" size="large" rounded="large"
                fillMode="solid" (click)="checkRequiredAttendees();stopClickPropagation($event)">
                Schedule
              </button>
            </div>
          </div>
        </div>
      </kendo-dialog-actions>
    </form>
  </div>
</kendo-dialog>

<kendo-dialog title="Please confirm" *ngIf="dateWarningDialogOpened" (close)="dateWarningAction(false)" height="auto"
  [width]="530" maxHeight="90vh" autoFocusedElement=".k-dialog-titlebar" class="date-warning-dialog">
  {{ dateWarningDialogMessage }}
  <kendo-dialog-actions>
    <button kendoButton (click)="dateWarningAction(false)">
      No
    </button>
    <button kendoButton (click)="dateWarningAction(true)" themeColor="primary">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>


<kendo-dialog title="Please confirm" *ngIf="confirmationDialog" (close)="closeConfirmationDialog()"
  (click)="stopClickPropagation($event)" class="custom-dialog cancel-confirmation-dialog" [height]="'auto'" [maxHeight]="'90vh'" [width]="'530'" autoFocusedElement=".k-dialog-titlebar">
  <p>Are you sure you want to cancel?</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeConfirmationDialog(); stopClickPropagation($event)" fillMode="solid">
      No
    </button>
    <button kendoButton (click)="onCancelSHM(); stopClickPropagation($event)" themeColor="primary" fillMode="solid">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="Please confirm" *ngIf="requiredConfirmationDialog" (close)="closeRequiredConfirmationDialog()"
  (click)="stopClickPropagation($event)" class="custom-dialog required-attendees-dialog" [height]="'auto'" [maxHeight]="'90vh'" [width]="'530'" autoFocusedElement=".k-dialog-titlebar">
  <p>Are you sure you want to schedule without all mandatory roles filled?</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeRequiredConfirmationDialog(); stopClickPropagation($event)" fillMode="solid">
      No
    </button>
    <button kendoButton (click)="confirmRequiredAttendees(); stopClickPropagation($event)" themeColor="primary" fillMode="solid">
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>